// Plan Features Configuration
export const PLAN_FEATURES = {
  hobby: {
    name: "Hobby",
    maxAgentRequests: 10, // per day
    maxTabCompletions: 50, // per day
    aiImageGeneration: false,
    videoEditing: false,
    websiteCreation: false,
    authenticationPayments: false,
    prioritySupport: false,
    apiAccess: false,
    usageMultiplier: 1,
    customAITraining: false,
    whiteLabel: false,
    earlyAccess: false,
  },
  pro: {
    name: "Pro",
    maxAgentRequests: Infinity,
    maxTabCompletions: Infinity,
    aiImageGeneration: true,
    videoEditing: true,
    websiteCreation: true,
    authenticationPayments: true,
    prioritySupport: true,
    apiAccess: false,
    usageMultiplier: 1,
    customAITraining: false,
    whiteLabel: false,
    earlyAccess: false,
  },
  "pro+": {
    name: "Pro+",
    maxAgentRequests: Infinity,
    maxTabCompletions: Infinity,
    aiImageGeneration: true,
    videoEditing: true,
    websiteCreation: true,
    authenticationPayments: true,
    prioritySupport: true,
    apiAccess: true,
    usageMultiplier: 3,
    customAITraining: true,
    whiteLabel: false,
    earlyAccess: false,
  },
  ultra: {
    name: "Ultra",
    maxAgentRequests: Infinity,
    maxTabCompletions: Infinity,
    aiImageGeneration: true,
    videoEditing: true,
    websiteCreation: true,
    authenticationPayments: true,
    prioritySupport: true,
    apiAccess: true,
    usageMultiplier: 20,
    customAITraining: true,
    whiteLabel: true,
    earlyAccess: true,
  },
};

// Check if user has access to a feature
export const hasFeature = (userPlan, feature) => {
  const plan = PLAN_FEATURES[userPlan?.toLowerCase()] || PLAN_FEATURES.hobby;
  return plan[feature] === true || plan[feature] === Infinity;
};

// Get plan limits
export const getPlanLimits = (userPlan) => {
  return PLAN_FEATURES[userPlan?.toLowerCase()] || PLAN_FEATURES.hobby;
};

// Check if user can perform an action
export const canPerformAction = (userPlan, actionType, currentUsage = {}) => {
  const limits = getPlanLimits(userPlan);
  
  switch (actionType) {
    case "agent_request":
      if (limits.maxAgentRequests === Infinity) return true;
      return (currentUsage.agentRequests || 0) < limits.maxAgentRequests;
    
    case "tab_completion":
      if (limits.maxTabCompletions === Infinity) return true;
      return (currentUsage.tabCompletions || 0) < limits.maxTabCompletions;
    
    case "image_generation":
      return limits.aiImageGeneration;
    
    case "video_editing":
      return limits.videoEditing;
    
    case "website_creation":
      return limits.websiteCreation;
    
    case "api_access":
      return limits.apiAccess;
    
    default:
      return false;
  }
};

// Get upgrade message for feature
export const getUpgradeMessage = (feature) => {
  const upgradePlans = {
    agent_request: "Pro",
    tab_completion: "Pro",
    image_generation: "Pro",
    video_editing: "Pro",
    website_creation: "Pro",
    api_access: "Pro+",
    custom_ai_training: "Pro+",
    white_label: "Ultra",
    early_access: "Ultra",
  };
  
  const plan = upgradePlans[feature] || "Pro";
  return `Upgrade to ${plan} plan to access this feature`;
};

